<template>
  <main class="home-page">
    <section class="hero">
      <div class="hero__top">
        <div class="profile">
          <VanImage v-if="userInfo.userimg" class="profile__avatar" width="36" height="36" round :src="avatarUrl">
            <div slot="error" class="profile__avatar-fallback">
              <span class="profile__avatar-head" />
              <span class="profile__avatar-body" />
            </div>
          </VanImage>
          <div v-else class="profile__avatar profile__avatar-fallback">
            <span class="profile__avatar-head" />
            <span class="profile__avatar-body" />
          </div>
          <h1>{{ greeting }}</h1>
        </div>

      </div>

      <div class="search-row">
        <div class="search-box">
          <input v-model.trim="searchText" type="search" :placeholder="$t('homeRedesign.searchPlaceholder')"
            @keydown.enter.prevent="searchProducts" />
          <div class="search-box__submit" role="button" tabindex="0" :aria-label="$t('homeRedesign.searchPlaceholder')"
            @click="searchProducts" @keydown.enter.prevent="searchProducts" @keydown.space.prevent="searchProducts">
            <Icon name="search" />
          </div>
        </div>
      </div>

      <div class="assistance" type="button" @click="toService">
        <Icon name="volume-o" />
        <div class="assistance__ticker">
          <NoticeBar :text="scrollNotice" color="var(--color-primary-strong)" background="transparent" scrollable />
        </div>
      </div>
    </section>

    <div class="quick-actions" :aria-label="$t('homeRedesign.quickActions')">
      <div v-for="item in quickActions" v-show="!item.hidden" :key="item.key" class="quick-action" @click="item.action">
        <span class="quick-action__icon">
          <img :src="item.icon" alt="" />
        </span>
        <span class="quick-action__label">{{ item.label }}</span>
      </div>
    </div>

    <div class="popular-section">
      <h2>
        <Icon name="fire" />
        <span>{{ $t('homeRedesign.popular') }}</span>
      </h2>
      <Products ref="products" />
    </div>

    <ActionSheet v-model="showLanguages" :actions="languageActions" :cancel-text="$t('Button.cancle')"
      close-on-click-action @select="selectLanguage" />

  </main>
</template>

<script>
import { ActionSheet, Icon, Image as VanImage, NoticeBar } from 'vant'
import { $get } from '@/utils/request'
import { getLanguage, lans, setLanguage } from '@/i18n'
import { getToken } from '@/utils/tools'
import Products from './component/popularProducts.vue'

export default {
  name: 'HomeRedesign',
  components: {
    ActionSheet,
    Icon,
    VanImage,
    NoticeBar,
    Products,
  },
  data() {
    return {
      currentLanguage: getLanguage(),
      searchText: '',
      showLanguages: false,
      serviceUrl: '',
      scrollNotice: '',
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo || {}
    },
    greeting() {
      const name = this.userInfo.username || this.$t('homeRedesign.guest')
      return this.$t('homeRedesign.greeting', { name })
    },
    avatarUrl() {
      const url = this.userInfo.userimg
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      return `${this.verConfig.url}${url}`
    },
    currentLanguageCode() {
      return (this.currentLanguage || 'en').toUpperCase()
    },
    languageActions() {
      return lans.map(item => ({
        name: item.name,
        value: item.value,
        color: item.value === this.currentLanguage ? 'var(--color-primary-strong)' : 'var(--color-text)',
      }))
    },
    quickActions() {
      return [
        {
          key: 'publish',
          label: this.$t('homeRedesign.publish'),
          icon: require('@/assets/new/product.png'),
          action: () => this.$router.push({ name: 'PublishProduct' }),
        },
        // {
        //   key: 'shipping',
        //   label: this.$t('homeRedesign.freeShipping'),
        //   icon: 'logistics',
        //   action: () => {},
        // },
        {
          key: 'withdraw',
          label: this.$t('homeRedesign.withdraw'),
          icon: require('@/assets/new/withdraw.png'),
          action: () => this.$router.push({ name: 'newWithdraw' }),
        },
        {
          key: 'about',
          label: this.$t('homeRedesign.about'),
          icon: require('@/assets/new/about.png'),
          action: () => this.$router.push({ name: 'aboutus' }),
        },
        {
          key: 'contact',
          label: this.$t('homeRedesign.contact'),
          icon: require('@/assets/new/service.png'),
          action: () => this.toService(),
        },
      ]
    },
  },
  watch: {
    searchText(value, previousValue) {
      if (!value && previousValue) this.searchProducts()
    },
  },
  created() {
    this.loadScrollNotice()
    this.$store.dispatch('getUserInfo')
    this.loadServiceUrl()
  },
  methods: {
    searchProducts() {
      if (this.$refs.products) this.$refs.products.reloadProducts(this.searchText)
    },
    async loadScrollNotice() {
      try {
        const response = await $get('/other/config', { act: 'system' })
        const responseData = response && response.data
        let notice = ''

        if (
          responseData &&
          Object.prototype.hasOwnProperty.call(responseData, 'scroll_notice')
        ) {
          notice = responseData.scroll_notice
        } else if (responseData && responseData.data) {
          notice = responseData.data.scroll_notice
        }

        this.scrollNotice = notice == null ? '' : String(notice)
      } catch (error) {
        this.scrollNotice = ''
      }
    },
    selectLanguage(item) {
      if (item.value === this.currentLanguage) {
        this.showLanguages = false
        return
      }
      this.currentLanguage = item.value
      this.$i18n.locale = item.value
      setLanguage(item.value)
      this.showLanguages = false
    },
    toService() {
      if (this.$api && this.$api.toService) {
        this.$api.toService()
        return
      }
      if (this.serviceUrl) window.location.href = this.serviceUrl
    },
    loadServiceUrl() {
      if (!this.$api || !this.$api.getNotice) return
      this.$api.getNotice(res => {
        this.serviceUrl = res.service_url || ''
        if (this.serviceUrl) localStorage.setItem('service_url', this.serviceUrl)
      })
    },
  },
}
</script>

<style lang="less" scoped>
@accent: var(--color-primary);
@text: var(--color-text);

button,
input {
  font: inherit;
}

button {
  border: 0;
  cursor: pointer;
}

.home-page {
  width: 100%;
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding-bottom: 8px;
  overflow: hidden;
  color: @text;
  background: var(--page-background);
  box-sizing: border-box;
}

.home-page /deep/ *,
.home-page /deep/ *::before,
.home-page /deep/ *::after {
  box-sizing: border-box;
}

.hero {
  overflow: hidden;
  color: @text;
  background: var(--color-surface);
  box-shadow: var(--card-shadow);
  border-radius: 24px 24px 0 0;

  &__top {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 30px 18px 4px;
  }

}

.profile {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;

  &__avatar {
    width: 36px;
    height: 36px;
    flex: 0 0 auto;
    overflow: hidden;
    background: linear-gradient(180deg, #efefef, #c9c9c9);
  }

  &__avatar-fallback {
    position: relative;
    overflow: hidden;
    background: linear-gradient(180deg, #eeeeee 0%, #bdbdbd 100%);
    border-radius: 50%;
  }

  &__avatar>&__avatar-fallback {
    width: 100%;
    height: 100%;
  }

  &__avatar-head {
    position: absolute;
    top: 7px;
    left: 50%;
    width: 13px;
    height: 13px;
    background: #ffffff;
    border-radius: 50%;
    transform: translateX(-50%);
  }

  &__avatar-body {
    position: absolute;
    right: 6px;
    bottom: -4px;
    left: 6px;
    height: 18px;
    background: #ffffff;
    border-radius: 50% 50% 0 0;
  }

  h1 {
    min-width: 0;
    margin: 0;
    overflow: hidden;
    color: @text;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: -0.5px;
    line-height: 1.15;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.language-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary-strong);
  background: transparent;
}

.language-button {
  gap: 2px;
  min-width: 30px;
  height: 30px;
  padding: 0 2px;
  font-size: 11px;
  font-weight: 700;

  .van-icon {
    font-size: 8px;
  }
}

.search-row {
  display: flex;
  align-items: center;
  padding: 14px 19px;
}

.search-box {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 18px;
  overflow: hidden;
  color: @accent;
  background: var(--page-background);
  border: 1px solid @accent;
  border-radius: 100px;

  .van-icon {
    flex: 0 0 auto;
    font-size: 22px;
  }

  &__submit {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    // padding: 4px;
    cursor: pointer;
  }

  input {
    width: 100%;
    min-width: 0;
    color: @text;
    font-size: 14px;
    letter-spacing: 0;
    background: transparent;
    border: 0;
    outline: none;

    &::placeholder {
      color: #9b9b9b;
      opacity: 1;
    }

    &::-webkit-search-cancel-button {
      display: none;
    }
  }
}

.assistance {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 18px;
  color: var(--color-primary-strong);
  text-align: left;
  background: transparent;
  border-top: 1px solid var(--color-primary-border);
  border-bottom: 1px solid var(--color-primary-border);

  .van-icon {
    flex: 0 0 auto;
    font-size: 18px;
  }

  &__ticker {
    min-width: 0;
    flex: 1;
    overflow: hidden;
  }

  /deep/ .van-notice-bar {
    width: 100%;
    height: 40px;
    padding: 0;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 40px;
  }

  /deep/ .van-notice-bar__wrap {
    height: 40px;
  }

  /deep/ .van-notice-bar__content {
    line-height: 40px;
    white-space: nowrap;
  }
}

.quick-actions {
  // display: flex;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  padding: 20px 0 14px 3px;
  overflow-x: auto;
  overflow-y: hidden;
  background: var(--page-background);
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .quick-action {
    // width: 80px;
    // min-width: 80px;
    // flex: 0 0 80px;
    padding: 0;
    color: @text;
    background: transparent;

    &__icon {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 10px;
      color: #ffffff;
      background: var(--color-primary-gradient);
      border-radius: 12px;

      img {
        width: 24px;
        height: 24px;
        display: block;
        object-fit: contain;
      }
    }

    &__label {
      height: 17px;
      display: block;
      overflow: hidden;
      padding: 0 2px;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 17px;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}


.popular-section {
  padding: 4px 19px 8px;
  background: var(--page-background);

  h2 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 12px;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0;

    .van-icon {
      color: @accent;
      font-size: 22px;
    }
  }
}

@media (max-width: 380px) {
  .profile h1 {
    max-width: 150px;
  }
}
</style>
